import { formatText } from 'core/i18n';
import { history } from 'routes/history';
import { BASE_PATH } from 'constants/index';
import { useSaveRegisterRequests } from 'components/newAccountSteps/initialStep/useSaveRegisterRequests';
import Storage from 'utilities/storage';

export const useLastSectionValidationAndRegister = ({
    flags,
    userProfile,
    userProfileForm,
    validateSection,
    actions,
    preLoaderActions,
    readyCaptchaToken,
}) => {
    const saveRegisterCallback = () => {
        Storage.cookies.remove('jointHolderInvite');
        preLoaderActions.hidePreLoader();
        history.push(`${BASE_PATH}/steps`);
    };
    const { handleSaveRequest } = useSaveRegisterRequests(flags, userProfile, actions, saveRegisterCallback);
    const handleValidationAndRegister = () => {
        if (!userProfileForm.$form.valid) return;
        validateSection();
        preLoaderActions.setInformationText(formatText('informationText-register'));
        preLoaderActions.showPreLoader();
        readyCaptchaToken(handleSaveRequest);
    };

    return { handleValidationAndRegister };
};
